import grey from "@mui/material/colors/grey";
import amber from "@mui/material/colors/amber";

export const CustomGroupStyles = () => {
    return {
        "& .custom-groups__filters-form": {
            marginBottom: "40px",
        },
        "& .form-advice": {
            padding: "10px",
            textAlign: "center",
            background: `${grey[50]}`,
            width: "100%",
            fontWeight: "bold"
        },
        "& .custom-groups__filter-actions": {
            display: "flex",
            justifyContent: "space-between"
        },
        "& .custom-groups__info-icon": {
            marginBottom: "-7px",
            marginRight: "4px",
        },
        // Cross-year warning highlighting for MCD mode
        "& .cross-year-warning": {
            backgroundColor: `${amber[50]} !important`,
            "&:hover": {
                backgroundColor: `${amber[100]} !important`,
            }
        },
        "& .cross-year-note": {
            marginTop: "10px",
            padding: "8px 12px",
            backgroundColor: `${amber[50]}`,
            borderLeft: `4px solid ${amber[500]}`,
            fontSize: "0.9em",
        },
        "& .cross-year-indicator": {
            display: "inline-block",
            width: "16px",
            height: "12px",
            backgroundColor: `${amber[50]}`,
            border: `1px solid ${amber[300]}`,
            marginRight: "6px",
            verticalAlign: "middle",
        }
    }
}